var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9706,
    height: 35.9706,
    rx: 17.9853,
    fill: "#FF3F4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M12.9375 12.9375L22.6406 22.6407",
    stroke: "white",
    strokeWidth: 1.62997,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M22.7168 12.9375L13.0137 22.6407",
    stroke: "white",
    strokeWidth: 1.62997,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupClose);
export default __webpack_public_path__ + "static/media/popup_close.79c3cfb4ebb12ee1fd6ab56882ff930c.svg";
export { ForwardRef as ReactComponent };